var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "answers_outline_24",
    clipPath: "url(#clip0_4035_50249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x86\xB3 Icon Color",
    d: "M6.25961 16.9282L6.25913 16.9277L6.2588 16.9273C5.81544 16.474 5.35651 16.004 4.9375 15.4938C3.87486 14.1998 3 12.5748 3 10C3 5.02937 7.00006 1 12 1C17 1 21 5 21 10C21 12.5748 20.1251 14.1998 19.0625 15.4937C18.6435 16.0039 18.1843 16.4743 17.7409 16.9277L17.7409 16.9277C17.6303 17.0407 17.5201 17.1534 17.4141 17.2633L18.1336 17.9577L17.4141 17.2633C16.9163 17.7791 16.4523 18.2901 16.0905 18.8542L16.0019 18.9923L15.9621 19.1515L15.4545 21.1821L15.4541 21.1837L15.4225 21.3107L15.4223 21.3116C15.2834 21.8731 15.1927 22.1812 15.0295 22.3991C14.8697 22.6126 14.6558 22.7796 14.4098 22.8829C14.1589 22.9883 13.838 23.0017 13.2595 23.0002H13.2587L13.1278 23H13.1261L10.8739 23L10.8722 23L10.7413 23.0002L10.7405 23.0002C10.162 23.0017 9.84109 22.9883 9.59015 22.8829C9.34425 22.7796 9.13034 22.6126 8.97047 22.3991C8.80732 22.1812 8.71656 21.8731 8.57766 21.3116L8.57746 21.3108L8.54593 21.1837L8.54552 21.1821L8.03787 19.1515L7.99808 18.9923L7.90949 18.8542C7.54773 18.2901 7.08373 17.7791 6.58594 17.2633L5.86636 17.9577L6.58594 17.2633C6.48065 17.1542 6.37117 17.0422 6.26138 16.93C6.26079 16.9294 6.2602 16.9288 6.25961 16.9282Z",
    stroke: "#AC92ED",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6787 10.7701C16.0243 11.201 15.9554 11.8307 15.5246 12.1763L13 14.201V18H16V20H8V18H11V14.2315L8.46175 12.1958C8.03091 11.8503 7.96206 11.2205 8.30759 10.7897C8.65312 10.3588 9.2828 10.2893 9.71365 10.6348L11.981 12.4532L14.2727 10.6153C14.7035 10.2698 15.3332 10.3393 15.6787 10.7701Z",
    fill: "#AC92ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4035_50249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswers);
export default __webpack_public_path__ + "static/media/answers.e55bf97ed200b6662ae2d42ae9279039.svg";
export { ForwardRef as ReactComponent };